<template>
  <v-list-item dense class="py-0" style="min-height: 40px">
    <v-list-item-avatar size="20" class="my-0 mr-2">
      <v-img v-if="fornitore_logo" :src="fornitore_logo" />
      <v-icon v-else small color="grey lighten-1">mdi-domain</v-icon>
    </v-list-item-avatar>
    <v-list-item-content class="py-1">
      <v-list-item-subtitle class="text-caption">
        <template v-if="fornitore">{{ fornitore.nome }} · </template
        >Lotto {{ lotto ? lotto.codice : "…" }}
      </v-list-item-subtitle>
      <v-list-item-subtitle class="text-caption grey--text">
        <template v-if="data_trapianto"
          >Trapianto {{ data_trapianto }}</template
        >
        <template v-else>Trapianto non disponibile</template>
        <template v-if="data_scadenza"> · Scadenza {{ data_scadenza }}</template>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import moment from "moment";

export default {
  name: "ColturaEventoElement",
  props: {
    // ColturaTrattata.to_json(): { id, id_coltura (= id_prodotto),
    // lotto_coltura (= id_lotto), fase_fenol }
    coltura: Object,
  },
  computed: {
    lotto() {
      let lotto = this.$store.getters.get_lotto_by_id(this.coltura.lotto_coltura);
      if (lotto) {
        return lotto;
      }
      this.$store.dispatch("get_lotto_by_id", this.coltura.lotto_coltura);
      return null;
    },
    fornitore() {
      if (!this.lotto) return null;
      return this.$store.getters.get_fornitore_by_id(this.lotto.id_fornitore);
    },
    fornitore_logo() {
      if (!this.fornitore) return null;
      return (
        process.env.VUE_APP_API_ROOT +
        "/fornitore/" +
        this.fornitore.id +
        "/avatar?t=" +
        this.fornitore.logo_md5
      );
    },
    // L'evento salva solo prodotto+lotto, non l'id della singola ColturaLotto
    // trattata: se lo stesso prodotto compare più volte nello stesso lotto
    // non è possibile distinguere quale sia stata trattata, quindi si prende
    // la prima corrispondenza come miglior approssimazione disponibile.
    coltura_associata() {
      if (!this.lotto) return null;
      return (
        (this.lotto.colture_associate || []).find(
          (c) => c.id_prodotto === this.coltura.id_coltura
        ) || null
      );
    },
    prodotto() {
      return this.$store.getters.get_prodotto_raw_by_id(this.coltura.id_coltura);
    },
    data_trapianto() {
      if (!this.coltura_associata || !this.coltura_associata.ts_trapianto) {
        return null;
      }
      return moment.unix(this.coltura_associata.ts_trapianto).format("DD MMMM YYYY");
    },
    // Stessa logica usata dal backend per escludere le colture scadute
    // (_coltura_scaduta): ts_trapianto + Specie.tempo_vendita (settimane).
    data_scadenza() {
      if (
        !this.coltura_associata ||
        !this.coltura_associata.ts_trapianto ||
        !this.prodotto
      ) {
        return null;
      }
      let specie = this.$store.getters.get_specie_by_id(this.prodotto.specie);
      if (!specie || !specie.tempo_vendita) return null;
      return moment
        .unix(this.coltura_associata.ts_trapianto)
        .add(specie.tempo_vendita, "weeks")
        .format("DD MMMM YYYY");
    },
  },
};
</script>
